<template>
	<div class="page-wrap login-page">
		<v-card width="600px">
			<v-card-title class="headline grey lighten-2 px-8"> Sign Up </v-card-title>

			<v-divider></v-divider>

			<div class="container px-8">
				<div class="row">
					<div class="col-sm-12">
						<v-text-field label="Username" v-model="username" :error-messages="usernameErrors" @input="$v.username.$touch()" @blur="$v.username.$touch()"></v-text-field>
					</div>
				</div>

                <div class="row">
					<div class="col-sm-12">
						<v-text-field label="Email" v-model="email" :error-messages="emailErrors" @input="$v.email.$touch()" @blur="$v.email.$touch()"></v-text-field>
					</div>
				</div>

				<div class="row">
					<div class="col-sm-12">
						<v-text-field label="Password" v-model="password" type="password" :error-messages="passwordErrors" @input="$v.password.$touch()" @blur="$v.password.$touch()"></v-text-field>
					</div>
				</div>

                <div class="row">
					<div class="col-sm-12">
						<v-text-field label="Password" v-model="confirmPassword" type="password" :error-messages="confirmPasswordErrors" @input="$v.confirmPassword.$touch()" @blur="$v.confirmPassword.$touch()"></v-text-field>
					</div>
				</div>
			</div>

			<v-card-actions class="headline grey lighten-2 px-8">
                <v-btn color="primary" text link to="/login"> Sign In </v-btn>
				<v-spacer></v-spacer>
				<v-btn @click="submit()" color="primary"> Sign Up </v-btn>
			</v-card-actions>
		</v-card>
	</div>
</template>

<script>
	import { validationMixin } from 'vuelidate';
	import { required } from 'vuelidate/lib/validators';

	import './style.scss';

	export default {
		name: 'Register',
		components: {},
		mixins: [validationMixin],
		validations: {
			password: { required },
			username: { required },
            email: { required },
            confirmPassword: { required }
		},
		data: () => {
            return {
				username: '',
				password: '',
                confirmPassword: '',
                email: ''
            }
		},
		
		computed: {
			passwordErrors () {
				const errors = [];

				if (!this.$v.password.$dirty){
					return errors;
				}

				!this.$v.password.required && errors.push('Password is required.');

				return errors;
			},
			usernameErrors () {
				const errors = [];
				if (!this.$v.username.$dirty){
					return errors;
				}

				!this.$v.username.required && errors.push('Username is required');

				return errors;
			},

            emailErrors () {
				const errors = [];
				if (!this.$v.email.$dirty){
					return errors;
				}

				!this.$v.email.required && errors.push('Username is required');

				return errors;
			},

            confirmPasswordErrors () {
				const errors = [];
				if (!this.$v.confirmPassword.$dirty){
					return errors;
				}

				(!this.$v.confirmPassword.required || this.confirmPassword != this.password) && errors.push('Username is required');

				return errors;
			}
		},

		methods: {
			submit() {
				this.$v.$touch();
			},

			clear () {
				this.$v.$reset()
				this.password = '';
				this.email = '';
			}
		}
	}
</script>

<style>

</style>
